module.exports = __webpack_public_path__ + "img/title_prefix.07619a5b.svg";